import React from 'react'
import {
  ListContainer,
  Container,
  TextBody,
  TextCaption,
  FieldText
} from '@pmi/pmi-iqos-ds-react'

const QuestPost575 = ({ questState, handleChangeInput, postInputErrorMap }) => {
  return (
    questState &&
    questState.components.map(component => {
      return (
        <Container
          key={component.id}
          p="4"
          borderColor={Container.borderColors.slate30}>
          <Container pb="4">
            <TextCaption size={TextCaption.sizes.l}>
              {component.topHeading}
            </TextCaption>
            <TextBody style={TextBody.styles.grayedout}>
              {component.heading}
            </TextBody>
          </Container>

          <ListContainer columns={1} yBetween="4">
            {component.items.map(item => {
              return (
                <FieldText
                  key={item.id}
                  name={item.id}
                  value={item.value}
                  label={item.placeholder}
                  errors={postInputErrorMap[item.id]}
                  onChangeHandler={handleChangeInput}
                  fullWidth
                />
              )
            })}
          </ListContainer>
        </Container>
      )
    })
  )
}

export default QuestPost575
